
require("../app");
require("bootstrap");


require("@fancyapps/fancybox");
require("slick-carousel");


//Slide Modelos
$(".modal").find(".model-ver-plantas").slick({
    arrows: true,
    autoplay: true,
    dots: false,
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    fade: true,
    pauseOnHover: false,
    nextArrow:
        '<a href="javascript:void(null);" class="slick-arrow slick-next">&rsaquo;</a>',
    prevArrow:
        '<a href="javascript:void(null);" class="slick-arrow slick-prev">&lsaquo;</a>',
}).on('afterChange', function () {
    $(".botones .boton").removeClass("activo");
    $(".imagenes-casa .imagen").removeClass("activo");

    $(".primer-modelo").addClass("activo");
    $(".primera-planta").addClass("activo");
});


$(".botones .boton").on("click", function () {
    $(".botones .boton").removeClass("activo");
    $(this).addClass("activo");

    var planta = $(this).data("planta");
    $(".imagenes-casa .imagen").removeClass("activo");
    $(planta).addClass("activo");

});